import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DeleteValidationResponseObj, IdToOrderObj, ValidationResponseObj} from '../../../../generated/generated-core.model';
import {DISPATCHER_PREFIX} from '../../../consts/data-service-consts';
import {Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class MxCollectionDataService {

    constructor(private httpClient: HttpClient) {
    }

    public getAll(url: string): Observable<Array<any>> {
        return this.httpClient.get<Array<any>>(DISPATCHER_PREFIX + url);
    }

    public changeOrder(url: string, newOrder: IdToOrderObj[]): Observable<null | ValidationResponseObj> {
        return this.httpClient.post<null | ValidationResponseObj>(DISPATCHER_PREFIX + url +  '/change-order', newOrder);
    }

    public delete(url: string, ids: Array<number>): Observable<ValidationResponseObj | string | null> {
        return this.httpClient.delete<ValidationResponseObj | string | null>(DISPATCHER_PREFIX + url +  `?ids=${ids}`);
    }

    public validateRemove(url: string, ids: Array<number>): Observable<DeleteValidationResponseObj> {
        return this.httpClient.get<DeleteValidationResponseObj>(DISPATCHER_PREFIX + url +  `/validate-delete?ids=${ids}`);
    }

    public update(url: string, ids: Array<number>): Observable<null | ValidationResponseObj> {
        return this.httpClient.put<null | ValidationResponseObj>(DISPATCHER_PREFIX + url, ids);
    }
}
